import { createApp } from "vue";
import App from "./components/App/App.vue";
import { createPinia } from "pinia";
import router from "./router";
import Vue3Tour from "vue3-tour";
import "vue3-tour/dist/vue3-tour.css";
import { VueShowdownPlugin } from "vue-showdown";

import.meta.glob("vue3-tour/dist/vue3-tour.css");

const pinia = createPinia();
const app = createApp(App);
app.use(Vue3Tour);

import vuetify from "./plugins/vuetify";
import { authStore } from "./stores/authStore";

app.use(pinia);
app.use(authStore);
app.use(vuetify);
app.use(router);
app.use(VueShowdownPlugin, {
  flavor: "github",
  options: {
    emoji: false,
    // The github flavor enables tablesHeaderId, which showdown 2.1.0 is vulnerable to
    // (GHSA-22g5-r2x5-97cx, stored XSS via table header ID injection). There is no fixed
    // showdown release, so keep it off: chat markdown is rendered via v-html.
    tablesHeaderId: false,
  },
});

app.directive("blur", {
  //  inserted: function (el) {
  //    /* @ts-expect-error  tbd*/
  //    el.onfocus = (ev) => ev.target.blur();
  //  },
});

app.mount("#root");
